import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, API } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { logger } from "@/lib/logger";

const Ctx = React.createContext(null);

export function ClientProvider({ children }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [selectedId, setSelectedId] = useState(() => {
    // Admin in view-as mode always lands on the impersonated client.
    const viewAs = sessionStorage.getItem("viewAsClientId");
    return viewAs || localStorage.getItem("selectedClientId") || "";
  });
  const [loading, setLoading] = useState(false);

  const reload = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/clients");
      setClients(data);
      // Honour view-as flag if present, otherwise the previously-saved one.
      const viewAs = sessionStorage.getItem("viewAsClientId");
      if (viewAs && data.find((c) => c.client_id === viewAs)) {
        setSelectedId(viewAs);
        localStorage.setItem("selectedClientId", viewAs);
      } else if (data.length && (!selectedId || !data.find((c) => c.client_id === selectedId))) {
        setSelectedId(data[0].client_id);
        localStorage.setItem("selectedClientId", data[0].client_id);
      }
    } catch (e) {
      logger.error("ClientContext reload failed:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) reload();
  }, [user?.user_id]);

  const select = (id) => {
    setSelectedId(id);
    localStorage.setItem("selectedClientId", id);
  };

  const selected = clients.find((c) => c.client_id === selectedId) || null;

  return (
    <Ctx.Provider value={{ clients, selectedId, selected, select, reload, loading, API, navigate }}>
      {children}
    </Ctx.Provider>
  );
}

export const useClients = () => React.useContext(Ctx);
